import {
  categoryMerchandising,
  FilterManager,
  KlevuFetch,
  KlevuSearchSorting,
  listFilters,
  personalisation,
  search,
  sendMerchandisingViewEvent,
  sendSearchEvent,
  advancedFiltering,
} from "@klevu/core";
import { getKlevuId } from "../klevu";

export default (query = "", type = "search") => ({
  // Variables
  clickManager: () => {
    console.log("productclick");
  },
  filterManager: null,
  limit: 24,
  latestResult: null,
  options: [],
  products: [],
  query: query,
  showMore: false,
  myFilters: [],
  sliders: [],
  loading: false,
  totalResultsFound: null,
  sort: KlevuSearchSorting.Relevance,
  sortOptions: [
    {
      key: KlevuSearchSorting.Relevance,
      name: klevuSorts[KlevuSearchSorting.Relevance],
    },
    {
      key: KlevuSearchSorting.PriceAsc,
      name: klevuSorts[KlevuSearchSorting.PriceAsc],
    },
    {
      key: KlevuSearchSorting.PriceDesc,
      name: klevuSorts[KlevuSearchSorting.PriceDesc],
    },
  ],
  type: type,
  // Getters
  get hasProducts() {
    return !!this.products.length;
  },
  get hasFilters() {
    return !!this.options.length;
  },
  get selectedSort() {
    return klevuSorts[this.sort];
  },
  get selectedFilters() {
    return this.filterManager.selectedFilters();
  },
  get sizeOptions() {
    return this.options.filter((option) => option.key.includes("size_"));
  },

  get otherOptions() {
    return this.options.filter(
      (option) => !option.key.includes("size_") && option.key !== "tags"
    );
  },

  get sizeOptionsSelected() {
    const filters = this.sizeOptions;
    const selectedOptionsCount = filters.reduce((count, filter) => {
      return count + filter.options.filter((option) => option.selected).length;
    }, 0);
    return selectedOptionsCount;
  },

  get sizeOptionsSelectedKey() {
    const filters = this.sizeOptions;
    const selectedOptionsKeys = filters.reduce((keys, filter) => {
      filter.options.forEach((option) => {
        if (option.selected && !keys.includes(filter.key)) {
          keys.push(filter.key);
        }
      });
      return keys;
    }, []);

    return selectedOptionsKeys;
  },

  // functions
  init() {
    this.filterManager = new FilterManager();

    this.readFromURLParams();
    this.search();

    this.$watch("query", this.search.bind(this));
  },

  clearAllFilters() {
    this.clearFilters(null);
  },

  clearFilters(key) {
    this.filterManager.clearOptionSelections(key);
    this.setMyFilters();
    this.updateUrl();
    this.search();
  },

  clearSizeFilters(keys) {
    keys.forEach((key) => {
      this.filterManager.clearOptionSelections(key);
    });
    this.setMyFilters();
    this.updateUrl();
    this.search();
  },

  handleFilterUpdate() {
    this.options = this.filterManager.options;
    this.sliders = this.filterManager.sliders;
    this.search();
    this.updateUrl();
  },

  readFromURLParams() {
    if ("URLSearchParams" in window) {
      // Browser supports URLSearchParams
      const params = new URLSearchParams(location.search);
      // Delete Shopify params
      params.delete("q");
      params.delete("type");
      params.delete("options[prefix]");
      if (params.size) {
        // load params to filterManager
        this.filterManager.readFromURLParams(params);
        //todo: load params to myFilters
        this.setMyFilters();
        return params.size;
      }
    }

    return;
  },

  updateUrl() {
    const KlevuParams = new URLSearchParams(this.filterManager.toURLParams());
    KlevuParams.set("q", this.query);
    window.history.replaceState({}, "", `${location.pathname}?${KlevuParams}`);
  },

  async search() {
    if (this.type === "category") {
      return this.categoryPageFetch();
    }
    return this.searchPageFetch();
  },
  async categoryPageFetch() {
    const filterManager = this.filterManager;

    const modifiers = [
      sendMerchandisingViewEvent(shopCollection.name),
      personalisation(),
      //Denna ska användas
      advancedFiltering(this.myFilters, "ANY_OF"),
    ];

    if (!this.options.length > 0) {
      await KlevuFetch(
        categoryMerchandising(
          shopCollection.name,
          {
            id: "search",
            limit: this.limit,
            sort: this.sort,
          },
          listFilters({
            filterManager: filterManager,
            limit: 200,
          })
        )
      );
      this.readFromURLParams();
      this.options = filterManager.options;
      this.sliders = filterManager.sliders;
    }

    const result = await KlevuFetch(
      categoryMerchandising(
        shopCollection.name,
        {
          id: "search",
          limit: this.limit,
          sort: this.sort,
          // campaignForCatNav: query.get("campaignId")
        },
        ...modifiers
      )
    );

    const searchResult = result.queriesById("search");
    if (!searchResult) {
      return;
    }

    this.sliders = filterManager.sliders;
    this.totalResultsFound = searchResult?.meta.totalResultsFound;
    this.latestResult = searchResult;
    this.showMore = searchResult.hasNextPage();
    this.options = filterManager.options;
    this.products = searchResult?.records;
    this.totalResultsFound = searchResult?.meta.totalResultsFound;
    // After Klevu product grid has loaded, hide the skeleton grid
    window.dispatchEvent(new CustomEvent("klevu-loaded"));
  },

  async searchPageFetch() {
    const query = this.query;
    const filterManager = this.filterManager;

    const modifiers = [
      sendSearchEvent(),
      personalisation(),
      advancedFiltering(this.myFilters, "ANY_OF"),
    ];

    if (!this.options.length > 0) {
      await KlevuFetch(
        search(
          query,
          {
            id: "search",
            limit: this.limit,
            sort: this.sort,
          },
          listFilters({
            filterManager: filterManager,
            limit: 200,
          })
        )
      );
      this.readFromURLParams();
      this.options = filterManager.options;
      this.sliders = filterManager.sliders;
    }

    const result = await KlevuFetch(
      search(
        query,
        {
          id: "search",
          limit: this.limit,
          sort: this.sort,
        },
        ...modifiers
      )
    );

    const searchResult = result.queriesById("search");
    if (!searchResult) {
      return;
    }

    this.latestResult = searchResult;
    this.showMore = searchResult.hasNextPage();
    this.options = filterManager.options;
    this.products = searchResult?.records;
    this.totalResultsFound = searchResult?.meta.totalResultsFound;
  },

  async fetchMore() {
    const nextRes = await this.latestResult.getPage();

    const searchResult = nextRes.queriesById("search");

    this.products = [...this.products, ...(searchResult?.records ?? [])];
    this.latestResult = searchResult;
    this.showMore = searchResult.hasNextPage();

    //this.updateUrl();
  },

  setMyFilters() {
    //for all options, if selected, add to myFilters
    for (let i = 0; i < this.filterManager.options.length; i++) {
      const option = this.filterManager.options[i];
      const key = option.key;
      const values = option.options
        .filter((option) => option.selected)
        .map((option) => option.name);

      //Look for key in myFilters
      const foundFilter = this.myFilters.find((filter) => filter.key === key);
      //If key is found and values, update it
      if (foundFilter && values.length > 0) {
        foundFilter.values = values;
      }
      //If key is found and no values, remove it
      else if (foundFilter && values.length == 0) {
        this.myFilters = this.myFilters.filter((filter) => filter.key !== key);
      }
      //If key is not found, add it
      else {
        if (values.length > 0) {
          this.myFilters.push({
            key: key,
            valueOperator: "INCLUDE",
            singleSelect: false,
            values: values,
          });
        }
      }
    }
  },

  handleFilter(key, name) {
    //toggle "selected" on option
    this.filterManager.toggleOption(key, name);

    //update myFilters
    this.setMyFilters();

    this.search();
    this.updateUrl();
  },

  async handleProductClick(event) {
    try {
      const id = event.currentTarget.getAttribute("data-id");
      const groupId = event.currentTarget.getAttribute("data-groupId");
      const name = event.currentTarget.getAttribute("data-name");
      const url = event.currentTarget.getAttribute("data-url");

      var klevuId = getKlevuId();
      if (!klevuId) {
        throw new Error("No Klevu ID available");
      }

      const raw = {
        klevu_apiKey: klevuId,
        klevu_keywords: this.query,
        klevu_type: "clicked",
        klevu_productId: id,
        klevu_productGroupId: groupId,
        klevu_productVariantId: id,
        klevu_productName: name,
        klevu_productUrl: url,
      };

      const baseUrl = "https://stats.ksearchnet.com/analytics/productTracking";

      // Function to build the query string
      const buildQueryString = (params) => {
        return Object.keys(params)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          )
          .join("&");
      };

      const fullUrl = `${baseUrl}?${buildQueryString(raw)}`;

      fetch(fullUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },

  async handleCategoryProductClick(event) {
    try {
      const id = event.currentTarget.getAttribute("data-id");
      const groupId = event.currentTarget.getAttribute("data-groupId");
      const name = event.currentTarget.getAttribute("data-name");
      const url = event.currentTarget.getAttribute("data-url");

      const category = event.currentTarget.getAttribute("data-category");
      const categoryName = category?.split(";;")[0];

      var klevuId = getKlevuId();
      if (!klevuId) {
        throw new Error("No Klevu ID available");
      }

      const raw = {
        klevu_apiKey: klevuId,
        klevu_categoryName: categoryName,
        klevu_categoryPath: category,

        klevu_productId: id,
        klevu_productGroupId: groupId,
        klevu_productVariantId: id,
        klevu_productName: name,
        klevu_productUrl: url,
      };

      const baseUrl =
        "https://stats.ksearchnet.com/analytics/categoryProductClickTracking";

      // Function to build the query string
      const buildQueryString = (params) => {
        return Object.keys(params)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          )
          .join("&");
      };

      const fullUrl = `${baseUrl}?${buildQueryString(raw)}`;

      fetch(fullUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },

  setSorting(event) {
    const sort = event.target.value;
    this.sort = sort;
    this.search();
  },

  dispatchFavoritesEvent() {
    const event = new CustomEvent("shopify-wishlist:KlevuLoaded", {});
    document.dispatchEvent(event);
  },
});
